module.exports = __webpack_public_path__ + "static/img/b1-5-4.de83088.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/b1-5-4.png
// module id = HwNV
// module chunks = 1